/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "view-order-schedule",
	props:{
		orderId:{
			default: null
		},
		orderDeliveryId:{
			default: null
		},
		orderDeliveryScheduleId:{
			default: null
		}
	},
	data() {
		return {
			order: {},
			orderGrandTotal: 0,
			orderSchedule: {},
			billingAddress:null,
			shippingAddress: null,
			totalForOrder: 0,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			orderItemsHeadings: [
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Quantity/Litres",
					field: "quantity"
				},
				// {
				// 	text: "Amount Dispensed",
				// 	field: "amountDispensed"
				// },
				{
					text: "Total",
					field: "totalAsString"
				},
				// {
				// 	text: "Total Price Dispensed",
				// 	field: "totalDispensedAsString"
				// }
			],
			vehicle: {},
			driver: {},
			actions: [],
			actionKeys:{
				edit: "edit",
				delete: "delete"
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			loadingBillingAddress: false,
			selectedHeartbeatStatusCodeId: null,
			sboModalEdit: {
				heading: "Edit SBO",
				modalId: "sboModalEdit",
				isSaving: false,
				showModal: false,
				sbo: {
					value: null,
					hasError: false,
					errorMessage: null
				}
			},
			successModal: {
				showModal: false,
				modalMessage: null,
				elementId: "viewOrderScheduleSuccessModal",
				modalHeading: "Success"
			},
			sboEditHistory: [],
			sboEditHistoryHeadings:[
				{
					text: "SBO",
					field: "sbo"
				},
				{
					text: "Updated On",
					field: "updatedOn"
				},
				{
					text: "Updated By",
					field: "updatedByUser"
				}
			],
			noDeliveryBatchModal:{
				showModal: false,
				modalId: "noDeliveryBatchModal",
				heading: "No Delivery Batch",
				message: "This order is not assigned to a delivery batch"
			}
		};
	},
	methods: {
		getOrder(){
			this.loading = true;
			orderService.getOrderForDelivery(this.orderId, this.orderDeliveryId).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.order = successResponse.data.result;
						this.order = dataTableHelper.castObjectValues(this.order);
						//this.order.orderItems = dataTableHelper.castObjectValues(this.order.orderItems);
						// for(let i = 0; i < this.order.orderItems.length; i++){
						// 	this.order.orderItems[i].priceAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].unitPrice);
						// 	this.order.orderItems[i].totalAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalAmount);
						// 	//this.order.orderItems[i].totalDispensedAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalPriceDispensed);
						// 	//this.order.total += this.order.orderItems[i].total;
						// }
						this.order.totalAsString = currencyHelper.numberToCurrency(this.order.totalAmount);
						this.orderGrandTotal = this.order.totalAmount;
						if(this.order.discountedAmount !== null && this.order.discountedAmount > 0) {
							this.orderGrandTotal = this.order.totalAmount - this.order.discountedAmount;
						}
						this.orderGrandTotal = currencyHelper.numberToCurrency(this.orderGrandTotal);
						console.log("order", this.order);
						this.setBreadcrumbs();
						this.getCustomerShippingAddress();
						this.getCustomerBillingAddress();
						this.getVehicle();
						this.getDriver();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getOrderDeliverySchedule(){
			this.loading = true;
			if(this.orderDeliveryScheduleId !== null){
				orderService.getOrderDeliverySchedule(this.orderDeliveryScheduleId, this.orderDeliveryId).then(
					successResponse =>{
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if(isSuccess){
							this.orderSchedule = successResponse.data.result;
						}
						this.loading = false;
					},
					errorResponse => {
						console.log("error", errorResponse);
						this.loading = false;
						apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					}
				);
			}
		},
		getVehicle(){
			this.loading = true;
			if(this.order.vehicleId !== null){
				systemService.getVehicle(this.order.vehicleId).then(
					successResponse =>{
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if(isSuccess){
							this.vehicle = successResponse.data.result;
						}
						this.loading = false;
					},
					errorResponse => {
						console.log("error", errorResponse);
						this.loading = false;
						apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					}
				);
			}
		},
		getDriver(){
			this.loading = true;
			if(this.order.driverId !== null){
				systemService.getDriver(this.order.driverId).then(
					successResponse =>{
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if(isSuccess){
							this.driver = successResponse.data.result;
						}
						this.loading = false;
					},
					errorResponse => {
						console.log("error", errorResponse);
						this.loading = false;
						apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					}
				);
			}
		},
		getCustomerShippingAddress(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.order.shippingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.shippingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerBillingAddress(){
			this.loadingBillingAddress = true;
			let request = {
				companyId: this.order.companyId
			};
			customerService.getCompanyBillingAddresses(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.result !== null && successResponse.data.result.length > 0){
							this.billingAddress = successResponse.data.result[0];
						}
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		// rescheduleOrder(){
		// 	this.$router.replace("/orders/scheduleOrderForDelivery/" + this.orderId + "/" + this.orderDeliveryId + "/" + this.orderDeliveryScheduleId);
		// },
		viewOrderSchedule(){
			console.log("orderDeliveryScheduleId", this.orderDeliveryScheduleId);
			if(this.orderDeliveryScheduleId === null){
				this.noDeliveryBatchModal.showModal = true;
			}
			else{
				this.$router.replace("/orders/delivery/scheduleDeliveryOrdersForDelivery/" + this.orderDeliveryScheduleId);
			}
		},
		onNoDeliveryBatchOkClick(){
			this.noDeliveryBatchModal.showModal = false;
		},
		downloadScheduleAsPdf(){
			orderService.getOrderScheduleAsPdf(this.orderId, this.orderDeliveryId);
		},
		onEditSboHistoryClick(){
			$("#editSboTrackingHistory").modal("show");
			orderService.getOrderDeliveryScheduleSboHistory(this.orderDeliveryId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.sboEditHistory = successResponse.data.result;
						this.sboEditHistory = dataTableHelper.castFieldValues(this.sboEditHistory);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onSboHistoryOkClick(){
			$("#editSboTrackingHistory").modal("hide");
		},
		onSboEditClick(){
			this.sboModalEdit.sbo.value = this.order.sbo;
			this.sboModalEdit.showModal = true;
		},
		onSboEditCloseClick(){
			this.sboModalEdit.showModal = false;
		},
		onSboEditSaveClick(){
			if(this.sboModalEdit.sbo.value === null || this.sboModalEdit.sbo.value === ""){
				this.sboModalEdit.sbo.hasError = true;
				this.sboModalEdit.sbo.errorMessage = "Please enter the SBO";
			}
			else {
				this.sboModalEdit.isSaving = true;
				let request = {
					orderDeliveryId: this.order.orderDeliveryId,
					sbo: this.sboModalEdit.sbo.value
				};
				orderService.updateOrderDeliveryScheduleSbo(request).then(
					successResponse => {
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if(isSuccess){
							if(successResponse.data.sboAlreadyExists){
								this.sboModalEdit.sbo.hasError = true;
								this.sboModalEdit.sbo.errorMessage = "SBO already exists";
							}
							else {
								this.sboModalEdit.showModal = false;
								this.sboModalEdit.sbo.hasError = false;
								this.sboModalEdit.sbo.errorMessage = null;
								this.order.sbo = this.sboModalEdit.sbo.value;
								this.successModal.modalMessage = "SBO updated successfully";
								this.successModal.showModal = true;
							}
						}
						this.sboModalEdit.isSaving = false;
					},
					errorResponse => {
						console.log("error", errorResponse);
						this.sboModalEdit.showModal = false;
						this.sboModalEdit.isSaving = false;
						apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					}
				)
			}
		},
		successModelOkClicked(){
			this.successModal.showModal = false;
		},
		setBreadcrumbs() {
			let pageTitle = "View Order Schedule - #" + this.order.orderId + " (" + this.order.registeredCompanyName + ")";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		permissionsHelper.setControlsBasedOnPermissions();
		//this.setBreadcrumbs();
		// this.getProvinces();
		// this.getShippingAreas();
		// this.getShippingZones();
	},
	watch:{
		orderId:{
			handler: function () {
				if (this.orderId !== null && this.orderId > 0) {
					this.getOrder();
				}
			},
			immediate: true,
			deep: true
		},
		orderDeliveryScheduleId:{
			handler: function () {
				console.log("orderDeliveryScheduleId", this.orderDeliveryScheduleId);
				if (this.orderDeliveryScheduleId !== null && this.orderDeliveryScheduleId > 0) {
					this.getOrderDeliverySchedule();
				}
			}
		}
	}
};